import { z } from 'zod';

export interface MetaDataCursorPage {
  cursor: string | null;
  size: number;
}

export interface JSONApiErrorResponse {
  errors?: JSONApiError[];
}

export interface JSONApiError {
  code: string;
  detail: string;
  source?: { pointer: string };
  title: string;
}

export const pagedMetaSchema = z.object({
  page: z.object({
    cursor: z.string().nullable(),
    has_next_page: z.boolean(),
    size: z.number(),
  }),
});
